// 초기 상태 선언
const initialState = {
  payment_id: '',
  order_arr: [],
};

// 액션 타입
const SET_AUTO_FORM = 'autoForm/SET_AUTO_FORM';
const CHANGE_AUTO_FORM = 'autoForm/CHANGE_AUTO_FORM';
const RESET_AUTO_FORM = 'autoForm/RESET_AUTO_FORM';

// 액션 생성함수
export const setAutoForm = data => ({
  type: SET_AUTO_FORM,
  data,
});

export const changeAutoForm = data => ({
  type: CHANGE_AUTO_FORM,
  data,
});

export const resetAutoForm = () => ({
  type: RESET_AUTO_FORM,
  autoForm: initialState,
});

// 리듀서 선언
export default function autoForm(state = initialState, action) {
  switch (action.type) {
    case SET_AUTO_FORM: {
      return action.data;
    }
    case CHANGE_AUTO_FORM: {
      const result = {
        ...state,
        order_arr: state.order_arr.map(item =>
          item.order_id === action.data.order_id ? { ...item, ...action.data } : item
        ),
      };
      return result;
    }
    case RESET_AUTO_FORM: {
      return action.autoForm;
    }
    default:
      return state;
  }
}
